import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgCloseLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 1L23 23M23 1L1 23"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgCloseLarge.displayName = 'SvgCloseLarge';
const CloseLarge = withForgeIconProps(SvgCloseLarge, {
  name: 'Close',
  usage: 'Use to close a window or overlay, remove an item, or clear a field.',
  related: 'x, delete, dismiss',
  isLabelRequired: false,
  isNeutralInteractive: true,
  size: 'large',
});
export default CloseLarge;
